import * as React from "react";
import Map from "components/atoms/MapBoat";
import styled from "styled-components";
import { Dialog } from "@material-ui/core";
import Card from "components/atoms/ItemCard";
import { navigate } from "gatsby";
import { useWindowWidth } from "@react-hook/window-size";
import { window } from "ssr-window";

type Props = {
  boothItems: any[];
  show: any;
};

const MapCollection = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-top: 0;
  /* margin-bottom: 2rem; */
  width: 748px;
  flex-wrap: wrap;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  @media (max-width: 768px) {
    width: 374px;
  }
`;

const SelectItem = styled.div`
  width: 300px;
`;

const MapItem = styled.div<{ width: number; index: number }>`
  width: 374px;
  height: 74px;
  cursor: pointer;
  flex: auto;
  transform: ${(props) =>
    props.width >= 768 && props.index % 2 ? "scale(-1, 1)" : ""};
`;

export default function Maps(props: Props) {
  const { boothItems, show } = props;
  const [selectedItem, setSelectedItem] = React.useState<any>(null);
  const width = useWindowWidth();
  return (
    <>
      <MapCollection>
        {boothItems.map(
          (item: any, index: number) =>
            item.mapIcon && (
              <MapItem
                width={width}
                index={index}
                onClick={() => {
                  if (item.mapIcon.url) {
                    setSelectedItem(item);
                  }
                }}
              >
                <Map image={item.mapIcon.url} />
              </MapItem>
            )
        )}
      </MapCollection>
      {selectedItem && (
        <Dialog open={!!selectedItem} onClose={() => setSelectedItem(null)}>
          <SelectItem
            onClick={() =>
              navigate(`/${show.slug}/boothitem/${selectedItem.id}`)
            }
          >
            <Card data={selectedItem} />
          </SelectItem>
        </Dialog>
      )}
    </>
  );
}
